module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/071-serbia-988390a55b27053378e6cdcae82a7eb4.svg";